import { render, staticRenderFns } from "./SimpleHTML.vue?vue&type=template&id=b6357dc8"
import script from "./SimpleHTML.vue?vue&type=script&lang=js"
export * from "./SimpleHTML.vue?vue&type=script&lang=js"
import style0 from "./SimpleHTML.vue?vue&type=style&index=0&id=b6357dc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports